import { useContext, useEffect } from 'react';

import { Polygon } from 'geojson';

import { MapContext } from '../MapContext';
import { mapDrawProjectBoundary } from '../utils/mapCommon';

export function useProjectBoundary(boundary?: Polygon) {
  const { refMap, mapReady, refStyleReady, mapStyle } = useContext(MapContext);

  useEffect(() => {
    const map = refMap?.current;
    if (!map || !mapReady || !refStyleReady.current || !boundary) return;
    mapDrawProjectBoundary(map, mapStyle, boundary);
  }, [mapReady, boundary, mapStyle]);
}
